import { render } from "./BackbeatDashboard.vue?vue&type=template&id=32961a56&scoped=true"
import script from "./BackbeatDashboard.vue?vue&type=script&lang=js"
export * from "./BackbeatDashboard.vue?vue&type=script&lang=js"

import "./BackbeatDashboard.vue?vue&type=style&index=0&id=32961a56&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32961a56"]])

export default __exports__